import React from 'react'
import assetlinks from "./../data/assetlinks.json";

export const AssetData = () => {
  return (
    <div>
        <pre>{JSON.stringify(assetlinks, null, 2)}</pre>
    </div>
  )
}
